<template lang="pug">
.faq-data-container(@click="expand = !expand")
  .faq-data
    .faq-id
      span.material-symbols-outlined(:class="`color-${data.brand}`") quiz
      span.tag(:class="`bg-${data.brand}`") {{ data.faq }}

    .faq-question(v-if="!history") {{ data.question }}

    .faq-active(v-if="!history")
      span.tag(:style="data.active ? 'background:#A5AA72;color:#fff' : 'background:#e9e9e7;color:#616161'") {{ data.active ? 'Activo' : 'Inactivo' }}

  transition(name="slide-fade")
    shForm.list-faq(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import mForm from '@/mixins/form'

export default {
  name: 'Faq',

  mixins: [mForm],

  components: { shForm },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.faq-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.faq-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.faq-id
  display flex
  align-items center
  gap .5em

.list-faq
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .faq-data
    column-gap 0
    row-gap 1em

  .faq-id
    width 12em
  .faq-question
    width 24em
  .faq-active
    width 7em
</style>



// WEBPACK FOOTER //
// src/components/pages/faq/Faq.vue